export default {
  className: 'commonProblem',
  fields: [
    {
      name: 'problem',
      validators: [
        (val) => val ? null : '问题不可为空'
      ]
    },
    {
      name: 'answer',
      validators: [
        (val) => val ? null : '答案不可为空'
      ]
    }
  ],
  search: [
  ],
  action: {
  }
}
